export class ModelBase {
    ID: string = '';
}